import { SentimentReportScore } from './sentiment-report-score.dto';

export type GetSelfSentimentReportResponseDto = SentimentReportScore;
